const INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'option',
    'label',
    '[role="button"]',
    '[role="menuitem"]',
    '[contenteditable="true"]',
].join(', ')

export const isInteractiveClick = (event: React.MouseEvent | any): boolean => {
    const target = event.target
    return (
        target instanceof Element &&
        Boolean(target.closest(INTERACTIVE_SELECTOR))
    )
}
